import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" {...props}><path fill="#1e1e1e" fillRule="evenodd" d="M9.586 8L3.293 1.707A1 1 0 014.707.293l7 7a1 1 0 010 1.414l-7 7a1 1 0 11-1.414-1.414L9.586 8z" /></svg>);